import Vue from 'vue'
import {
    ValidationObserver,
    ValidationProvider,
    extend,
    localize
} from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
import * as rules from "vee-validate/dist/rules";

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
localize("zh_CN", zh_CN);
extend('email', {
    validate(value) {
        return {
            required: false,
            valid: /\w+([-+.]\w+)*@\w+([-_.]\w+)*\.\w+([-_.]\w+)*/.test(value)
        };
    },
    computesRequired: true
});

extend('phone', {
    validate(value) {
        return {
            required: false,
            valid: /[1][3-8]\d{9}|\d{7,12}|(\d{4}|\d{3})-(\d{7,8})/.test(value)
        };
    },
    computesRequired: true
});

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);